import React from 'react';
import { useSurvey } from './Context';
import { years } from '../components/Years';

const YearFilter = () => {
    const { selectedYear, setYear } = useSurvey();

    const handleYearChange = (event) => {
        const newYear = event.target.value;

        window.dataLayer.push({
            event: 'survey_year_select',
            value: newYear,
            page: window.location.pathname,
        });

        setYear(newYear);
    };

    return (
        <div className="filter-item">
            <label className="sr-only" htmlFor="year_filter">Survey Year</label>
            <select
                className="filter-select"
                name="year_filter"
                id="year_filter"
                value={selectedYear}
                onChange={handleYearChange}
            >
                {years.map( year => {
                    return <option key={year} value={year}>{year}</option>
                } )}
            </select>
        </div>
    );
};

export default YearFilter;
